// ControlPlayReportButtonFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import PlayReportButtonControlView from 'advanced-inputs/PlayReportButtonControlView.js';

//=============================================================================
//
// Creates a show report button control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Maty Rocha, February 2016
//
//=============================================================================
class ControlPlayReportButtonFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        //adding silent(accessibility) to attributes.
		attributes.inlineEditable = true;
        
        attributes.silent = false;
        attributes.text = 'Show Report';
        attributes.styleBGColorText = '#FFFFFF';
        attributes.styleBGColor2Text = '#FFFFFF';
        attributes.styleBGColorOverText = '#FFFFFF';
        attributes.styleBGColorOver2Text = '#FFFFFF';
        attributes.styleBGColorDownText = '#FFFFFF';
        attributes.styleBGColorDown2Text = '#FFFFFF';
        attributes.gridData = [
            {'name':'Item 1', 'source': 'value 1', 'formula':  'selected'},
            {'name':'Item 2', 'source': 'value 2', 'formula':  'selected'},
            {'name':'Item 3', 'source': 'value 3', 'formula':  'selected'}
        ];
        attributes.borderStyle = 'solid';

        attributes.buttonStyle ='~buttonStyle';
        attributes.styleColorText ='~buttonTextColor';
        attributes.styleColorTextDown ='~buttonTextDownColor';
        attributes.styleColorTextOver ='~buttonTextOverColor';
        attributes.fontFamily = '~buttonFont';
        attributes.fontSize = '~buttonFont';
        attributes.textWeight = '~buttonFont';
        attributes.textStyle  = '~buttonFont';
        attributes.cornerRadius= '~buttonRadius';
        attributes.borderColor = '~buttonBorderColor';
        attributes.backgroundColor = '~buttonBgColor';
        attributes.advancedBgGradientColor = '~buttonBgGradientColor';
        attributes.advancedBgColorOver = '~buttonBgOverColor';
        attributes.advancedBgGradientColorOver = '~buttonBgGradientOverColor';
        attributes.advancedBgColorDown = '~buttonBgDownColor';
        attributes.advancedBgGradientColorDown = '~buttonBgGradientDownColor';

        attributes.CustomParameters = { parameter: []};
        attributes.selectedReport = {};
        attributes.selectedReportId = '';
        attributes.parameterTitle = 'Custom Parameters';
        attributes.resizePadding = 2;
        attributes.resizePaddingH = 0;
		attributes.minWidth = 10;
        attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

        return new PlayReportButtonControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );
    }

}

const controlPlayReportButtonFactory = new ControlPlayReportButtonFactory();
export default controlPlayReportButtonFactory;
